<template>
  <CModal :show.sync="show" size="lg" class="small-table-padding">
    <template #header>
      <h6 class="modal-title">{{ action + " Test" }}</h6>
      <CButtonClose @click="CloseModal" />
    </template>
    <CRow>
      <CCol sm="6" md="6">
        <label>Select Role</label>
        <v-select
          name="testCategory"
          v-model="test.type"
          :items="testCategoryOption"
          v-validate="'required'"
          outlined
          hide-details
        />
        <span class="text-danger">{{ errors.first("testCategory") }}</span>
      </CCol>
      <CCol sm="6" md="6">
        <CInput
          name="testname"
          label="Test Name"
          v-validate="'required'"
          v-model="test.name"
          placeholder="Name"
        />
        <span class="text-danger">{{ errors.first("testname") }}</span>
      </CCol>
      <CCol sm="6" md="6">
        <CInput
          label="Report By Day"
          v-model="test.report_by_day"
          name="report_by_day"
          v-validate="'required'"
          placeholder="Report By Day"
        />
        <span class="text-danger">{{ errors.first("report_by_day") }}</span>
      </CCol>
      <CCol sm="6" md="6">
        <label>Select Test Type</label>
        <v-select
          v-model="test.category"
          name="testoption"
          :items="testTypeOptions"
          outlined
          hide-details
        />
      </CCol>

      <CCol sm="6" md="6" class="commonmarginbox">
        <v-checkbox v-model="is_fasting" label="Fasting Required" color="primary" :value="1" />
      </CCol>

      <CCol sm="6" md="6">
        <label>Fasting Hours</label>
        <v-select v-if="is_fasting > 0" v-model="test.fasting" :items="fastingHourOption" outlined />
      </CCol>
      <CCol sm="6" md="6" class="tr-box commonmarginbox">
        <v-radio-group v-model="test.home_service" label="Home service">
          <div class="d-flex justify-content-space-bet align-items-start radiolabelwidth">
            <v-radio label="Yes" color="primary" :value="1" />
            <v-radio label="No" color="primary" :value="0" />
          </div>
        </v-radio-group>
      </CCol>

      <CCol sm="6" md="6" class="commonmarginbox">
        <v-textarea name="advice" v-model="test.advice" color="teal">
          <template v-slot:label>
            <div>Advice</div>
          </template>
        </v-textarea>
      </CCol>
    </CRow>
    <!-- <CRow>
      
    </CRow>-->
    <template #footer>
      <CButton @click="CloseModal" color="danger">Cancel</CButton>
      <CButton @click="Submit" color="success">{{ action + " Test" }}</CButton>
    </template>
  </CModal>
</template>

<script>
import config from "@/config.js";

export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      testCategoryOption: ["Pathology", "Radiology", "Other"],
      testCategory: "",
      testTypeOptions: ["Regular", "Special"],
      testType: "Regular",
      type: "All",
      showFasting: true,
      fastingHourOption: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      fasting: 0,
      is_fasting: 0
    };
  },
  props: ["test", "action", "show"],
  watch: {
    testCategory: function(newValue) {
      if (newValue) {
        if (newValue == "Pathology") {
          showFasting = false;
        } else {
          showFasting = true;
        }
      }
    }
  },
  created() {
    this.is_fasting = this.test.fasting != 0 ? 1 : 0;
  },
  methods: {
    CloseModal() {
      this.$emit("close");
    },
    Submit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$emit("submit", this.test);
        }
      });
    }
  }
};
</script>
